import { useEffect } from 'react'

import useRequest from '@space-shell/common/hooks/useRequest'
import { MembershipEndpoints, MembershipService } from '@space-shell/common/services/membership'

import { ProductEndpoints } from '@space-shell/common/services/product'
import { SectionsEndpoints } from '@space-shell/common/services/sections'

import { queryClient } from '@space-shell/config/request'
import { useMembershipStore } from '@space-shell/core/store'

import { useParentInfoStore } from '@space-shell/remotes/preview/store/parentInfo'

enum EventNames {
  invalidatePreviewRequests = 'app-space:invalidatePreviewRequests'
}

const useEventHandler = () => {
  const { setMembershipData } = useMembershipStore()
  const { membershipSlug, membershipId, sections } = useParentInfoStore()

  const { isLoading: isLoadingMembershipInfo } = useRequest(
    [MembershipEndpoints.info(membershipSlug)],
    () => MembershipService.getInfo(membershipSlug),
    {
      enabled: Boolean(membershipSlug),
      onSuccess: (data) => setMembershipData(data)
    }
  )

  useEffect(() => {
    const invalidatePreviewRequests = async () => {
      await Promise.all([
        queryClient.invalidateQueries([MembershipEndpoints.info(membershipSlug)]),
        queryClient.invalidateQueries([SectionsEndpoints.sections(membershipId)]),
        queryClient.invalidateQueries([ProductEndpoints.sale(membershipSlug)]),
        sections?.forEach((sectionId) => {
          queryClient.invalidateQueries([SectionsEndpoints.sectionsItems(membershipId, sectionId)])
        })
      ])
    }

    window.addEventListener(EventNames.invalidatePreviewRequests, invalidatePreviewRequests)

    return () => {
      window.removeEventListener(EventNames.invalidatePreviewRequests, invalidatePreviewRequests)
    }
  }, [membershipSlug, membershipId, sections])

  return {
    isLoading: isLoadingMembershipInfo
  }
}

export default useEventHandler
